interface IBaseApiError {
  instance: string
  traceId: string
  specie: ApiErrorSpecies
}

export interface ISingleApiError extends IBaseApiError {
  specie: ApiErrorSpecies.Single
  type: string
  error: string
  detail: string
}

export interface IMultipleApiError extends IBaseApiError {
  specie: ApiErrorSpecies.Multiple
  errors: Array<IMultipleApiErrorItem>
}

export interface IMultipleApiErrorItem {
  type: string
  error: string
  detail: string
  field: string | null
}

export enum ApiErrorSpecies {
  Single = 0,
  Multiple = 1,
}

export type ApiError = ISingleApiError | IMultipleApiError

export enum InternalHandledErrorTypes {
  Unknown = 'Unknown',
  InvalidData = 'InvalidData',
  Authentication = 'Unauthorized',
  Authorization = 'NotAllowed',
  NotFound = 'ResourceNotFound',
  ServiceUnavailable = 'ServiceUnavailable',
}
